export const orderCondition = ['평점', '재구매율'];
